import { render, staticRenderFns } from "./CashStatementPage.vue?vue&type=template&id=5328a605&scoped=true&"
import script from "./CashStatementPage.vue?vue&type=script&lang=ts&"
export * from "./CashStatementPage.vue?vue&type=script&lang=ts&"
import style0 from "./CashStatementPage.vue?vue&type=style&index=0&id=5328a605&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328a605",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
